import React, { PropTypes, Component } from 'react'
import styles from '../styles'
import CellDiv from './cellDiv'
import misc from 'utils/misc'
import md5 from 'blueimp-md5'

export default class PasswordCell extends Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  constructor (props) {
    super(props)
    this.onChange = (e) => {
      props.onChange(props.dataKey, md5(e.target.value))
    }
  }

  shouldComponentUpdate (nextProps) {
    // you need to avoid update by passing same items object to it
    const compareKeys = ['width']
    return !misc.isObjectEqual(this.props, nextProps, compareKeys)
  }

  render () {
    return (
      <CellDiv width={this.props.width} className={styles.inputCell}>
        <input
          ref="input"
          type="password"
          placeholder="輸入新密碼"
          onChange={this.onChange}
        />
      </CellDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataCell/passwordCell.jsx